import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
    createStyles({
        paper: {
            margin: 'auto',
            overflow: 'hidden',
        },
        searchBar: {
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
            paddingBottom: theme.spacing(1),
        },
        searchInput: {
            fontSize: theme.typography.fontSize,
        },
        block: {
            display: 'block',
        },
        addUser: {
            marginRight: theme.spacing(1),
        },
        contentWrapper: {
            margin: '40px 16px',
        },
    });

const useStyles = makeStyles(styles);

interface IProps {
    placeholder: string;
    buttonText: string;
    onButtonClick: () => void;
    onSearchChange: (event: any) => void;
}

export default ({ placeholder, onButtonClick, buttonText, onSearchChange }: IProps) => {
    const classes = useStyles();
    return (
        <AppBar className={classes.searchBar} position="static" color="default" elevation={0}>
            <Toolbar>
                <Grid container spacing={2} alignItems="center">
                    <Grid item>
                        <SearchIcon className={classes.block} color="inherit" />
                    </Grid>
                    <Grid item xs>
                        <TextField
                            fullWidth
                            placeholder={placeholder}
                            InputProps={{
                                disableUnderline: true,
                                className: classes.searchInput,
                            }}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    onSearchChange(event);
                                }
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <Button
                            onClick={onButtonClick}
                            variant="contained"
                            color="primary"
                            className={classes.addUser}
                        >
                            {buttonText}
                        </Button>
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    );
};
